var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.noMore)?_c('div',{staticClass:"load-more"},[_vm._v("亲，没有更多的数据了 ~")]):_c('div',{staticClass:"load-more"},[_c('img',{staticClass:"loading_icon",attrs:{"src":require("./img/icon_loading.png")}}),_vm._v("正在努力加载中...\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }